<template>
  <div id="assessment" style="background: #eee;">
    <v-container class="mt-1">
      <v-row>
        <v-col cols="12" lg="6" md="6" sm="7" xs="12">
          <div class="mb-5 pl-1 hidden-sm-and-up">
            <h1 class="mb-2">
              Instant revenue self assessment
              <br />
            </h1>
            <span>
              Tax assessment and payment just got easier. Simply enter your
              details below and our system will run your tax assessment.
            </span>
          </div>
          {{ this.$store.state.drawer }}
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step :complete="e1 > 1" step="1"
                >Income Sources</v-stepper-step
              >

              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 2" step="2"
                >Tax Deductions</v-stepper-step
              >

              <v-divider></v-divider>

              <v-stepper-step step="3">Result</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card class="mb-12" color=" lighten-1">
                  <v-form>
                    <v-text-field
                      v-model="income.salaries"
                      label="Gross Income, Salary, Allowances/annum"
                      single-line
                      outlined
                      v-currency="{ currency: 'NGN', locale: 'en' }"
                      ref="salaries"
                    ></v-text-field>
                    <v-text-field
                      v-model="income.commission"
                      label="Commission, Bonuses, Garuities/annum"
                      single-line
                      outlined
                      v-currency="{ currency: 'NGN', locale: 'en' }"
                      ref="commission"
                    ></v-text-field>
                    <v-text-field
                      v-model="income.dividends"
                      label="Dividends, Interest, Rents, etc./annum"
                      single-line
                      outlined
                      v-currency="{ currency: 'NGN', locale: 'en' }"
                      ref="dividends"
                    ></v-text-field>
                  </v-form>
                </v-card>

                <v-btn color="primary" @click="e1 = 2">Continue</v-btn>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card class="mb-12" color="white lighten-1">
                  <v-form>
                    <v-text-field
                      v-model="deductions.pension"
                      label="Pension Contribution/annum"
                      single-line
                      outlined
                      v-currency="{ currency: 'NGN', locale: 'en' }"
                      ref="pension"
                    ></v-text-field>
                    <v-text-field
                      v-model="deductions.nhf"
                      label="NHF Contribution/annum"
                      single-line
                      outlined
                      v-currency="{ currency: 'NGN', locale: 'en' }"
                      ref="nhf"
                    ></v-text-field>
                    <v-text-field
                      v-model="deductions.nhis"
                      label="NHIS Contribution/annum"
                      single-line
                      outlined
                      v-currency="{ currency: 'NGN', locale: 'en' }"
                      ref="nhis"
                    ></v-text-field>
                    <v-text-field
                      v-model="deductions.assurance"
                      label="Life Assurance Premium/annum"
                      single-line
                      outlined
                      v-currency="{ currency: 'NGN', locale: 'en' }"
                      ref="assurance"
                    ></v-text-field>
                    <v-text-field
                      v-model="deductions.gratuity"
                      label="Gratuity/annum"
                      single-line
                      outlined
                      v-currency="{ currency: 'NGN', locale: 'en' }"
                      ref="gratuity"
                    ></v-text-field>
                  </v-form>
                </v-card>

                <v-btn color="primary" @click="runAssessment">Continue</v-btn>

                <v-btn text @click="e1 = 1">Go Back</v-btn>
              </v-stepper-content>

              <v-stepper-content step="3">
                <div class="result-card">
                  <div class="grid-col">
                    <div class="result-col" style="border-bottom:none;">
                      <h2>Assessment Result</h2>
                      <span class="value">NGN</span>
                    </div>
                    <div class="result-col">
                      <span class="title">Gross Income</span>
                      <span class="value">{{
                        result.grossIncome | currencyFormat
                      }}</span>
                    </div>
                    <div class="result-col">
                      <span class="title">Tax Deductions</span>
                      <span class="value">{{
                        result.taxDeductions | currencyFormat
                      }}</span>
                    </div>
                    <div class="result-col">
                      <span class="title">Tax Relief</span>
                      <span class="value">{{
                        result.taxRelief | currencyFormat
                      }}</span>
                    </div>
                    <div class="result-col">
                      <span class="title">Taxabale Income</span>
                      <span class="value">{{
                        result.taxableIncome | currencyFormat
                      }}</span>
                    </div>
                    <div class="result-col">
                      <span class="title">Tax due:</span>
                      <span class="value">{{
                        result.taxDue | currencyFormat
                      }}</span>
                    </div>
                    <div class="result-col">
                      <span class="title">Monthly Tax:</span>
                      <span class="value">{{
                        (result.taxDue / 12) | currencyFormat
                      }}</span>
                    </div>
                  </div>
                </div>
                <v-row>
                  <v-btn class="result-btn" color="primary" @click="e1 = 1"
                    >Finish</v-btn
                  >
                  <SaveAssessmentDialog :tax="result" :deductions="deductions">
                    <v-btn
                      class="result-btn block"
                      color="primary"
                      @click="showDialog"
                      >Save Assessment</v-btn
                    >
                  </SaveAssessmentDialog>
                </v-row>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
        <v-col cols="12" md="5" lg="5" sm="5" offset-lg="1" offset-md="1">
          <right-panel></right-panel>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import RightPanel from "../components/assessment-right-panel";
import SaveAssessmentDialog from "../components/save-assessment-modal.vue";
import { getValue } from "vue-currency-input";
export default {
  components: {
    RightPanel,
    SaveAssessmentDialog,
  },
  data() {
    return {
      isValidating: true,
      openSaveAssessmentDialog: false,
      e1: 1,
      income: {
        salaries: "",
        commission: "",
        dividends: "",
      },
      deductions: {
        pension: "",
        nhf: "",
        nhis: "",
        assurance: "",
        gratuity: "",
      },
      result: {
        grossIncome: "0.00",
        taxDeductions: "0.00",
        taxRelief: "0.00",
        taxableIncome: "0.00",
        taxDue: "0.00",
      },
      locale: "en",
      currency: "NGN",
    };
  },
  methods: {
    showDialog() {
      return this.$store.dispatch("changeSaveAssessmentDialog", true);
    },
    runAssessment() {
      let gross =
        getValue(this.$refs.salaries) +
        getValue(this.$refs.commission) +
        getValue(this.$refs.dividends);

      let totalDeductions =
        getValue(this.$refs.pension) +
        getValue(this.$refs.nhf) +
        getValue(this.$refs.nhis) +
        getValue(this.$refs.assurance) +
        getValue(this.$refs.gratuity);

      let taxableIncome = 0.0;
      let taxPayable = 0.0;
      // let totalTaxExemptions = 0.0;
      let totalTaxRelief = 0.0;

      let taxReliefAmount = 200000.0;

      let onePercent = 0.01,
        twentyPercent = 0.2,
        sevenPercent = 0.07,
        elevenPercent = 0.11,
        fifteenPercent = 0.15,
        nineteenPercent = 0.19,
        twentyOnePercent = 0.21,
        twentyFourPercent = 0.24;

      let cappedValue = 300000.0;

      if (gross < cappedValue) {
        taxPayable = gross * onePercent;

        // console.log("Taxable Income One:  $taxableIncome");
        // console.log("Tax Payable $taxPayable");
      } else {
        if (taxReliefAmount > onePercent * gross) {
          totalTaxRelief = twentyPercent * gross + taxReliefAmount;
        } else {
          totalTaxRelief = onePercent * gross + twentyPercent * gross;
        }

        // console.log("Computed Tax Relief: $totalTaxRelief");

        taxableIncome = gross - (totalTaxRelief + totalDeductions);

        if (taxableIncome < cappedValue) {
          taxPayable = sevenPercent * taxableIncome;
        } else {
          let firstTaxValue = 0.0;
          let secondTaxValue = 0.0;
          let thirdTaxValue = 0.0;
          let fourthTaxValue = 0.0;
          let fifthTaxValue = 0.0;
          let sixthTaxValue = 0.0;
          let newTaxable = taxableIncome;

          //        Check for first 300,000
          firstTaxValue = sevenPercent * cappedValue;

          newTaxable = newTaxable - cappedValue;

          //        Check for second 300,000
          if (newTaxable > cappedValue) {
            secondTaxValue = elevenPercent * cappedValue;
            newTaxable -= cappedValue;
          } else {
            secondTaxValue = elevenPercent * newTaxable;
            newTaxable -= newTaxable;
          }

          //        Check for first 500,000
          if (newTaxable >= 500000.0) {
            thirdTaxValue = fifteenPercent * 500000.0;
            newTaxable -= 500000.0;
          } else {
            thirdTaxValue = fifteenPercent * newTaxable;
            newTaxable -= newTaxable;
          }

          //        Check for second 500,000
          if (newTaxable >= 500000.0) {
            fourthTaxValue = nineteenPercent * 500000.0;
            newTaxable -= 500000.0;
          } else {
            fourthTaxValue = nineteenPercent * newTaxable;
            newTaxable -= newTaxable;
          }

          //      Check for 1,600,000
          if (newTaxable >= 1600000.0) {
            fifthTaxValue = twentyOnePercent * 1600000.0;
            newTaxable -= 1600000.0;
          } else {
            fifthTaxValue = twentyOnePercent * newTaxable;
            newTaxable -= newTaxable;
          }

          //        Check for above 3,200,000
          if (newTaxable > 3200000) {
            sixthTaxValue = twentyFourPercent * newTaxable;
            newTaxable -= 3200000;
          }
         else {
          sixthTaxValue = twentyFourPercent * newTaxable;
          newTaxable -= newTaxable;
        }
          //

          taxPayable =
            firstTaxValue +
            secondTaxValue +
            thirdTaxValue +
            fourthTaxValue +
            fifthTaxValue +
            sixthTaxValue;
        }
      }

      this.result.taxableIncome = taxableIncome;
      this.result.taxDue = taxPayable;
      this.result.taxRelief = totalTaxRelief;
      this.result.taxDeductions = totalDeductions;
      this.result.grossIncome = gross;

      this.e1 = 3;
    },
  },
};
</script>
<style>
.assessment {
  background: red !important;
}

.v-stepper {
  box-shadow: none !important;

  border-radius: 20px !important;
}

#assessment .v-stepper .v-stepper_wrapper .v-card.v-sheet {
  display: none !important;
}
.v-stepper__header {
  box-shadow: none !important;
}
.v-stepper__content {
  background: #fff !important;
  border-radius: 40px 40px 0px 0px;
}

#assessment .v-text-field fieldset,
.v-text-field .v-input__control,
.v-text-field .v-input__slot {
  border-radius: 10px !important;
}

#assessment .v-card {
  box-shadow: none;
}

#assessment .result-card {
  border: 1px solid white;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0px 1px 10px 2px grey;
  margin: 20px 20px;
}

#assessment .result-col {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dotted;
  padding: 10px 0;
}

#assessment .result-btn {
  margin-left: 22px;
  margin-top: 10px;
}
</style>
